<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
    v-card
      v-card-title.px-4
        v-spacer
        .text-lg.font-bold Collect {{ loyaltySystem }}
        v-spacer
      v-divider
      div.py-6.px-8
        template(v-if="step === 0")
          value-to-collect(:loyaltySystem="loyaltySystem" :member.sync="selectedMember" :memberSelectable="memberSelectable" :valueToCollect.sync="collectValue" :purchasedValue.sync="purchasedValue" :valueCollected="valueCollected" :rewardsPosition="rewardsPosition")
        template(v-if="step === 1")
          value-collected(:loyaltySystem="loyaltySystem" :member="selectedMember" :postCollectedData="postCollectedData" :valueToCollect.sync="collectValue" @redeem="handleRedeem")
      v-divider
      v-card-actions.px-6
        v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
        v-spacer
        v-btn.button-md.neutral700.white--text(v-if="step === 1" depressed @click="closeDialog") {{ $t('finish') }}
        v-btn.button-md.neutral700.white--text(v-else :loading="isLoading" depressed :disabled="isDisabledContinue" @click="handleCollect") {{ $t('collect') }}
</template>

<script>
import ValueToCollect from "@/components/clinic/checkout/marketing/collecting/ValueToCollect.vue";
import ValueCollected from "@/components/clinic/checkout/marketing/collecting/ValueCollected.vue";
import {mapActions, mapGetters} from "vuex";
import clone from "just-clone";

export default {
  components: {
    ValueCollected,
    ValueToCollect
  },
  props: {
    open: {
      type: Boolean,
    },
    member: {
      type: Object,
      default: null
    },
    rewardsPosition: {
      type: Array,
      default: () => ([])
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    memberSelectable: {
      type: Boolean,
    }
  },
  data() {
    return {
      step: 0,
      collectValue: 1,
      purchasedValue: null,
      isLoading: false,
      postCollectedData: null,
      selectedMember: null
    }
  },
  mounted() {
    if (this.member) {
      this.selectedMember = clone(this.member)
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isDisabledContinue () {
      if (this.step === 0) {
        return !this.selectedMemberId || this.collectValue <= 0 || !this.collectValue || this.purchaseValuePriceInteger < 0 || this.purchaseValuePriceInteger === null
      }
      return false
    },
    selectedMemberId() {
      return this.selectedMember?.id
    },
    purchaseValuePriceInteger() {
      const purchasedValue = this.purchasedValue
      if (!purchasedValue) return null
      return parseInt(parseFloat(purchasedValue).toFixed(this.$currency.exponent) * this.$currency.multiplier)
    },
    collectValuePayload() {
      return {
        collect_value: this.collectValue,
        purchased_value: this.purchaseValuePriceInteger,
        type: this.loyaltySystem
      }
    },
    valueCollected () {
      return this.selectedMember?.collected
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    async handleCollect() {
      if (this.step === 0) {
        const requested = await this.handleCollectValue()
        if (requested) {
          this.step = 1
        }
      }
    },
    async handleCollectValue() {
      this.isLoading = true
      try {
        const url = `/loyalty/${this.company.slug}/members/${this.selectedMemberId}/collects`
        const { data } = await this.$axios.post(url, this.collectValuePayload)
        this.postCollectedData = data
        this.$emit('refetch')
        this.updateActivityLog(url, this.collectValuePayload, data, 'POST', `Collect ${this.loyaltySystem}`, data.id)
        return true
      }
      catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      }
      finally {
        this.isLoading = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'Collect stamp',
        activity: activity,
        raw_data: { endpoint, payload, response: response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {})
    },
    handleRedeem () {
      this.$emit('redeem', this.selectedMember)
      this.showDialog = false
    }
  },
}
</script>

<style scoped>
</style>